import React, { useState } from 'react';
import { Button, Spinner } from 'reactstrap';
import { usePractitioner } from '../../contexts/practitioner';
import produce from 'immer';
import { putPractitioner } from '../../apis/practitioner';

const TogglePractitionerStatus = () => {
  const [loading, setLoading] = useState(false);
  const { practitioner, setPractitioner } = usePractitioner();
  return (
    <Button
      className="float-right mr-2"
      color={
        practitioner ? (practitioner.active ? 'danger' : 'success') : 'info'
      }
      disabled={!practitioner}
      onClick={async () => {
        if (!practitioner) return;
        try {
          setLoading(true);
          const modified = produce(practitioner, draft => {
            draft.active = !draft.active;
          });
          if (!modified || !modified.id) return;
          const response = await putPractitioner(modified.id, modified);
          if (!response) return;

          setPractitioner(modified);
        } finally {
          setLoading(false);
        }
      }}>
      {loading ? (
        <Spinner size="sm" />
      ) : practitioner ? (
        practitioner.active ? (
          'Disable Access'
        ) : (
          'Enable Access'
        )
      ) : (
        'Error'
      )}
    </Button>
  );
};
export default TogglePractitionerStatus;
